export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCSklI9zwiPxKlFRptSXJvAXrh_KPu1oNQ",
    authDomain: "west-oaks-fe502.firebaseapp.com",
    databaseURL: "https://west-oaks-fe502.firebaseio.com",
    projectId: "west-oaks-fe502",
    storageBucket: "west-oaks-fe502.appspot.com"
  }
};



// WEBPACK FOOTER //
// /Users/trevor/src/src-westoaks3/west-oaks/src/environments/environment.ts